import React, { lazy, Suspense, useState, useEffect } from 'react';

import { useStartTutorial, useFirebaseClaims } from 'utils/hooks';

const OnboardingTutorialProviderLazyComponent = lazy(() => import('./index'));

const OnboardingTutorialProviderLazy: React.FC<
  React.PropsWithChildren<ComponentProps<typeof OnboardingTutorialProviderLazyComponent>>
> = (props) => {
  const [shouldLoad, setShouldLoad] = useState(false);
  const { claims } = useFirebaseClaims();

  useStartTutorial(() => setShouldLoad(true));

  useEffect(() => {
    if (claims?.showOnboardingTutorial) {
      setShouldLoad(true);
    }
  }, [claims]);

  return shouldLoad ? (
    <Suspense fallback={null}>
      <OnboardingTutorialProviderLazyComponent {...props} />
    </Suspense>
  ) : (
    <>{props.children}</>
  );
};

export default OnboardingTutorialProviderLazy;
